export class UserHttpError extends Error {
  public statusCode: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = 'UserHttpError';
    this.statusCode = status;
  }
}
